import { z } from 'zod';
import { DnsRrTypeSchema } from '@terra/shared-schemas-orchestrator';
import {
  CloudAccountPolicyProviderSchema,
  CloudAccountPolicyStatusSchema,
} from './external-network.schema';

export const DnsZoneDelegationStatusSchema = z.enum([
  'PENDING_VERIFICATION',
  'VERIFIED',
  'MISMATCH',
  'UNVERIFIABLE',
]);

export const DnsZoneAutoScopeSchema = z.enum(['IN_SCOPE', 'OUT_OF_SCOPE']);

export const DnsZoneSurfaceAttachmentSchema = z.object({
  provider: CloudAccountPolicyProviderSchema,
  connected: z.boolean(),
  attached: z.boolean(),
  zoneId: z.string().nullable(),
  zoneRef: z.string().nullable(),
  zoneName: z.string().nullable(),
  accountRef: z.string().nullable(),
  connectionId: z.string().nullable(),
  isPrivate: z.boolean(),
  recordCount: z.number().int().nullable(),
  lastSyncedAt: z.coerce.date().nullable(),
  status: CloudAccountPolicyStatusSchema.nullable(),
  lastError: z.string().nullable(),
  enabled: z.boolean().nullable(),
  autoScope: DnsZoneAutoScopeSchema.nullable(),
  recordExclusionPatterns: z.array(z.string()),
  delegationStatus: DnsZoneDelegationStatusSchema.nullable(),
  nameservers: z.array(z.string()),
  observedNameservers: z.array(z.string()),
});

export const ListDnsZoneSurfaceAttachmentsResponseSchema = z.object({
  attachments: z.array(DnsZoneSurfaceAttachmentSchema),
});

export const DnsZoneSurfaceProviderBodySchema = z.object({
  provider: CloudAccountPolicyProviderSchema,
  zoneId: z.string().min(1).optional(),
  connectionId: z.string().min(1).optional(),
});

export const DnsZoneSurfaceAttachBodySchema =
  DnsZoneSurfaceProviderBodySchema.extend({
    zoneId: z.string().min(1),
    autoScope: DnsZoneAutoScopeSchema.optional(),
  });

export const DnsZoneSurfaceDetachBodySchema =
  DnsZoneSurfaceProviderBodySchema.extend({
    zoneId: z.string().min(1),
  });

export const DnsZonePolicyPathParamsSchema = z.object({
  surfaceId: z.string(),
  zoneId: z.string(),
});

export const UpdateDnsZonePolicyBodySchema = z.object({
  enabled: z.boolean().optional(),
  autoScope: DnsZoneAutoScopeSchema.optional(),
  recordExclusionPatterns: z.array(z.string().min(1)).optional(),
});

export const DnsZonePolicyDtoSchema = z.object({
  zoneId: z.string(),
  enabled: z.boolean(),
  autoScope: DnsZoneAutoScopeSchema,
  recordExclusionPatterns: z.array(z.string()),
});

export const ListDnsZoneRecordsQuerySchema = z.object({
  skip: z.coerce.number().int().min(0).optional(),
  limit: z.coerce.number().int().min(1).max(200).optional(),
  rrType: DnsRrTypeSchema.optional(),
  search: z.string().optional(),
});

export const DnsZoneRecordDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  rrType: DnsRrTypeSchema,
  ttl: z.number().int().nullable(),
  rdata: z.array(z.string()),
  setIdentifier: z.string(),
  isAlias: z.boolean(),
  isProxied: z.boolean(),
  lastSeenAt: z.coerce.date(),
  deprovisionedAt: z.coerce.date().nullable(),
});

export const ListDnsZoneRecordsResponseSchema = z.object({
  data: z.array(DnsZoneRecordDtoSchema),
  total: z.number().int(),
});
